import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import Image from "../../Utils/getImage";
import instance from "../../Utils/api";
import CommonTable from "./Common_table";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ViewDelivers = ({ openviewDialog, setopenviewDialog, selectedDelivers }) => {
  const [deliveredOrderDetails, setDeliveredOrderDetails] = useState(null);
  const [subOrdersDelivered, setSubOrdersDelivered] = useState([]);

  //handle close
  const handleClose = () => {
    setopenviewDialog(false);
  };

  const columns = [
    { label: "S.No", field: "sno",  },
    { label: "Name", field: "name",  },
    { label: "Status", field: "suborder_status", },
    { label: "Fabric Status", field: "fabric_status", },
    { label: "Fabric Given", field: "consultationsleft", },
    { label: "Quantity", field: "quantity", },
    { label: "size", field: "size", },
    // { label: "OrderId", field: "orderid", },
    // { label: "Action", field: "actions",  },
  ]

  const fetchOrderById = async () => {
    try {
      const response = await instance.get(`/Order/OrderById?order_id=${selectedDelivers?._id}`);
      setDeliveredOrderDetails(response?.data?.data);
      const subOrdersData = response.data.data.sub_orders.map((suborder, index) => ({
        sno: index + 1,
        orderid: suborder._id,
        name: suborder?.design_id?.name,
        suborder_status: suborder?.status,
        quantity: suborder?.quantity,
        consultationsleft: suborder?.fabric_given === true ? "Yes" : "No",
        fabric_status: suborder?.fabric_status,
        size: suborder?.size,
        // Bannerimage: suborder?.design_id?.picture[0],
        // date: new Date(suborder?.design_id?.createdAt).toISOString().split('T')[0],
        // assignperson: deliveredOrderDetails?.assigned_to?.name,
        // suborder_category: suborder?.design_id?.category,
        // suborder_subCategory: suborder?.design_id?.subCategory,
        // suborder_design_type: suborder?.design_id?.design_type,

        // mobile: deliveredOrderDetails?.customer_id?.mobile
      }));
      setSubOrdersDelivered(subOrdersData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (selectedDelivers) {
      fetchOrderById();
    }
  }, [selectedDelivers]);
  // console.log(subOrdersDelivered);


  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openviewDialog}
        className="admin-admins"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Delivered order info
          <Typography>
            See the delivered order details for more information
          </Typography>
        </DialogTitle>
        <hr style={{ margin: "8px 0px" }} />
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <section className="add-order">
            <div className="add-employee-title">
              <Typography>Delivered orders booking person info</Typography>
            </div>
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_emloyee-upload-file">
                  <Image
                    src={deliveredOrderDetails?.customer_id?.profile_pic}
                    alt="upload_image"
                    width={244}
                    height={171}
                  />
                  <Typography variant="h5">
                    {deliveredOrderDetails?.customer_id?.name}
                  </Typography>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                <div className="order-content-text">
                  <Typography variant="h5">Customer details</Typography>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Mobile number</Typography>
                    <Typography>
                      {deliveredOrderDetails?.customer_id?.mobile}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Birth Date</Typography>
                    <Typography>
                      {new Date(deliveredOrderDetails?.customer_id?.dob).toLocaleDateString()}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Gender</Typography>
                    <Typography>
                      {deliveredOrderDetails?.customer_id?.Gender}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Location</Typography>
                    <Typography>
                      {deliveredOrderDetails?.customer_id?.location}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Consultations Left</Typography>
                    <Typography>
                      <span style={{
                        backgroundColor: deliveredOrderDetails?.customer_id?.consultations_left === "Yes" ? "#E1FCEF" : "#FFEDEF",
                        color: deliveredOrderDetails?.customer_id?.consultations_left === "Yes" ? "#14804A" : "#D1293D",
                        padding: "5px 15px",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}>
                        {deliveredOrderDetails?.customer_id?.consultations_left === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Size</Typography>
                    <Typography>
                      {deliveredOrderDetails?.customer_id?.size}
                    </Typography>
                  </div>
                </div>
                <div className="order-content-text" style={{ marginTop: 20 }}>
                  <Typography variant="h5">Order details</Typography>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Order Status</Typography>
                    <Typography>
                      <span style={{
                        backgroundColor: (() => {
                          switch (deliveredOrderDetails?.status) {
                            case "Unassigned":
                              return "#FFC107"; // Yellow
                            case "Assigned":
                              return "#03A9F4"; // Blue
                            case "Delivered":
                              return "#4CAF50"; // Green
                            case "In Payment":
                              return "#000"
                            case "In Progress":
                              return "#3c4ce7"
                            case "In Transit":
                              return "#e74c3c"
                            case "Completed":
                              return "#4CAF50"; // Shared Green for these statuses
                            case "Canceled":
                              return "#F44336"; // Red for Canceled
                            default:
                              return "#E0E0E0"; // Default Gray for unknown status
                          }
                        })(),
                        color: (() => {
                          switch (deliveredOrderDetails?.status) {
                            case "Unassigned":
                              return "#212121"; // Dark text for Yellow
                            case "Assigned":
                              return "#fff";
                            case "Delivered":
                              return "#fff";
                            case "In Payment":
                              return "#fff";
                            case "In Progress":
                              return "#fff";
                            case "In Transit":
                              return "#fff"; // White text for other statuses
                            case "Completed":
                              return "#fff"; // White text for other statuses
                            case "Canceled":
                              return "#fff"; // White text for other statuses
                            default:
                              return "#757575"; // Light gray text for default
                          }
                        })(),
                        padding: "5px 10px",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}>
                        {deliveredOrderDetails
                          ? deliveredOrderDetails?.status
                          : "---"}
                      </span>
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment Status</Typography>
                    <Typography>
                      {deliveredOrderDetails?.payment_status || "---"}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Paid Amount</Typography>
                    <Typography>
                      {deliveredOrderDetails?.paid_amount || "---"}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment Amount</Typography>
                    <Typography>
                      {deliveredOrderDetails
                        ? deliveredOrderDetails?.payment_amount
                        : "---"}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Pending Amount</Typography>
                    <Typography>
                      {deliveredOrderDetails?.pending_amount || "---"}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Paid Amount</Typography>
                    <Typography>
                      {deliveredOrderDetails?.paid_amount || "---"}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content" >
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Ordered date</Typography>
                    <Typography>{deliveredOrderDetails?.createdAt ? new Date(deliveredOrderDetails?.createdAt).toLocaleString() : '---'}</Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Delivered Date</Typography>
                    <Typography>{deliveredOrderDetails?.deadline ? new Date(deliveredOrderDetails?.deadline).toLocaleString() : '---'}</Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
            <hr style={{ margin: "10px 0px" }} />
            <div className="order-content-text" >
              <Typography variant="h5">Sub Order details</Typography>
            </div>
            <CommonTable
              columns={columns}
              rows={subOrdersDelivered}
            />
          </section>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewDelivers;
